import { FC } from 'react';
import { AssetUser, UserData } from '../models';
import PropTypes from 'prop-types';
import { Box, IconButton, Tooltip } from '@mui/material';
import DeleteTwoToneIcon from '@mui/icons-material/DeleteTwoTone';
import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import { useTranslation } from 'react-i18next';
import { Card, Tables } from 'src/shared/components/index';
import { I18N } from 'src/shared/constants/constants';
interface UserAssetsProps {
  userAssetsList: AssetUser[];
  handleDeleteIconClick(row: any): void;
}

const UserAssetsTable: FC<UserAssetsProps> = ({
  userAssetsList,
  handleDeleteIconClick
}) => {
  const handleDeleteIconClickEvent = (row) => {
    handleDeleteIconClick(row);
  };

  const { t } = useTranslation(I18N.SECRET_MANAGEMENT);
  const columns: GridColDef[] = [
    {
      field: ' ',
      flex: 0.1
    },
    {
      field: 'name',
      sortable: false,
      headerName: t('name'),
      flex: 4
    },
    {
      field: 'description',
      sortable: false,
      headerName: t('description'),
      flex: 4
    },
    {
      field: t('actions'),
      sortable: false,
      flex: 2,
      renderCell: (params: GridRenderCellParams<any>) => {
        return (
          <Tooltip title={t('delete')} arrow>
            <IconButton
              color="inherit"
              size="small"
              className="RecentOrderDeleteButton ml-8"
              onClick={() => handleDeleteIconClickEvent(params.row)}
            >
              <DeleteTwoToneIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        );
      }
    }
  ];

  return (
    <>
      <Card>
        <Box flex={1}>
          <Tables
            rows={userAssetsList}
            columns={columns}
            checkboxSelection={false}
          />
        </Box>
      </Card>
    </>
  );
};
UserAssetsTable.propTypes = {
  userAssetsList: PropTypes.array.isRequired
};

UserAssetsTable.defaultProps = {
  userAssetsList: []
};
export default UserAssetsTable;
